import styled, {css} from 'styled-components';

import {scToTwColour} from '../../theme';

export default styled.div<{$isHovered: boolean}>`
  border: 2px dashed ${scToTwColour('theme.colours.slate7')};
  color: ${scToTwColour('theme.colours.slate11')};
  font-weight: 700;
  font-size: 0.9em;
  padding: 5px;
  text-align: center;
  outline: none;
  cursor: pointer;
  transition: all ${({theme}) => theme.transition};

  &:hover {
    border-color: ${scToTwColour('theme.colours.slate8')};
    color: ${scToTwColour('theme.colours.blue11')};
  }

  ${({$isHovered}) =>
    $isHovered &&
    css`
      &,
      &:hover {
        border-color: ${scToTwColour('theme.colours.blue8')};
        color: ${scToTwColour('theme.colours.white')};
      }
    `};
`;
